import { DefaultService } from "@/api/SolarCloudApi";
import { QueryConfig } from "@/lib/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export default function getPersonalAllocationsQueryOptions() {
  return queryOptions({
    queryKey: ["personalAllocations"],
    queryFn: getPersonalAllocations,
    refetchOnWindowFocus: false,
  });
}

async function getPersonalAllocations() {
  const response = await DefaultService.getPersonalAllocations();
  return response?.collection ?? [];
}

type usePersonalAllocationsOptions = {
  queryConfig?: QueryConfig<typeof getPersonalAllocationsQueryOptions>;
};

export function usePersonalAllocations({
  queryConfig,
}: usePersonalAllocationsOptions = {}) {
  return useQuery({
    ...getPersonalAllocationsQueryOptions(),
    ...queryConfig,
  });
}
